import { fetchData } from './dataApi';

export const VOCABULARY_ROOTS = {
  thematic: 'thematic-vocabulary',
  wordclass: 'wordclass-vocabulary',
};

let catalogPromise;

export function loadVocabularyCatalog() {
  if (!catalogPromise) {
    catalogPromise = Promise.all([
      fetchData(`${VOCABULARY_ROOTS.thematic}/index.json`),
      fetchData(`${VOCABULARY_ROOTS.wordclass}/index.json`),
    ]).then(([thematic, wordclass]) => ({
      thematic: thematic.topics || [],
      wordclass: wordclass.topics || [],
    })).catch((error) => {
      catalogPromise = null;
      throw error;
    });
  }
  return catalogPromise;
}

function overlayById(sourceItems = [], overlayItems = []) {
  const overlays = new Map(overlayItems.map((item) => [item.id, item]));
  return sourceItems.map((item) => ({ ...item, ...(overlays.get(item.id) || {}) }));
}

export function mergeVocabularyOverlay(source, overlay, locale) {
  const overlaySections = new Map((overlay?.sections || []).map((section) => [section.id, section]));
  const sections = (source.sections || []).map((section) => {
    const localized = overlaySections.get(section.id);
    return {
      ...section,
      ...localized,
      items: overlayById(section.items, localized?.items),
    };
  });

  const content = {};
  sections.forEach((section) => {
    section.items.forEach((item) => {
      content[item.id] = { ...item, sectionId: section.id, sectionLabel: section.label };
    });
  });

  const topic = { ...(source.topic || {}), ...(overlay?.topic || {}) };

  return {
    schemaVersion: 2,
    locale,
    id: topic.id,
    label: topic.label || topic.id || '',
    icon: topic.icon || '',
    topic,
    sections,
    content,
  };
}

export async function loadVocabularyTopic(type, locale, topicId, options) {
  const root = VOCABULARY_ROOTS[type];
  if (!root) throw new Error(`Unknown vocabulary type: ${type}`);
  const source = await fetchData(`${root}/en/${topicId}.json`, options);
  const overlay = locale === 'en'
    ? null
    : await fetchData(`${root}/${locale}/${topicId}.json`, options).catch(() => null);
  return mergeVocabularyOverlay(source, overlay, locale);
}

export function clearVocabularyCatalogCache() {
  catalogPromise = null;
}
